import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { PermissionListInterface } from '../types/permission-list';
import {
  PermissionListFilter,
  defaultPermissionListFilter,
} from '../types/permission-list-filter';

export const PERMISSION_LIST_STATE = 'permissionList';

export interface PermissionListState {
  filter: PermissionListFilter;
  dataSource: DataSource<PermissionListInterface[]>;
}

export const initialDataSource: DataSource<PermissionListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialPermissionListState: PermissionListState = Object.freeze({
  filter: defaultPermissionListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
